import { createContext } from 'react'

const customerContext = createContext()

export default customerContext
